import { render, staticRenderFns } from "./ViewAgentkyc.vue?vue&type=template&id=dc0fb264"
import script from "./ViewAgentkyc.vue?vue&type=script&lang=js"
export * from "./ViewAgentkyc.vue?vue&type=script&lang=js"
import style0 from "./ViewAgentkyc.vue?vue&type=style&index=0&id=dc0fb264&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports